const PodcastButtonPlay = () => {
	const listenBtn = document.querySelector('.podcast-single__play');
	const playBtn = document.querySelector('.play-btn');

	if (listenBtn && playBtn) {
		listenBtn.addEventListener('click', () => {
			const clickEvent = new MouseEvent('click', { shiftKey: true });
			playBtn.dispatchEvent(clickEvent);
		});
	}
};

export default PodcastButtonPlay;
